import { getSystemTypes, SystemType } from "@api";
import { FilterType, Table } from "@components";
import { Cell, Row } from "@components/table/types";
import { Form } from "@components";
import { Box, Grid, Button, Typography, IconButton } from "@material-ui/core";
import * as React from "react";
import { useState } from "react";
import { Route, Switch, useRouteMatch } from "react-router";
import { M_TABLE_HEADERS_SYSTEMTYPE } from "../constants";
import { useHistory } from "react-router-dom";
import {
  createStyles,
  Theme,
  withStyles,
  WithStyles,
} from "@material-ui/core/styles";
import { SystemTypeDetails } from "./detail";
import { useEffect } from "react";
import { MaintenanceBreadcrumbs } from "../breadcrumbs";
import { exportBusinessUnitsToExcel } from "@api/excel-exporters/exportBusinessUnits";

const headers: Cell[] = [
  { data: M_TABLE_HEADERS_SYSTEMTYPE.NAME },
  { data: M_TABLE_HEADERS_SYSTEMTYPE.IS_ACTIVE },
];

const formatBool = (status: boolean): string => {
  return status ? "Yes" : "No";
};

const styles = (theme: Theme) =>
  createStyles({
    root: {
      margin: 0,
      padding: theme.spacing(2),
    },
    closeButton: {
      position: "absolute",
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
  });

export interface DialogTitleProps extends WithStyles<typeof styles> {
  id: string;
  children: React.ReactNode;
  onClose: () => void;
}

type FormValues = {
  name: string;
  isActive: boolean;
};

export type SelectedItem = {
  selectedEnv: SystemType;
};

type Key = keyof FormValues;

export const SystemTypes: React.FC = () => {
  const [environmentList, setEnvironment] = useState<Row<SystemType>[]>([]);
  const [isLoading, setIsloading] = useState<boolean>(true);
  const [open, setOpen] = React.useState<boolean>(false);
  const [selectedItem, setSelectedItem] = React.useState<
    SystemType | undefined
  >(undefined);
  const [environmentListMain, setEnvironmentMain] = useState<Row<SystemType>[]>(
    []
  );
  const [isHideInactiveRecords, setIsHideInactiveRecords] = useState<boolean>(
    true
  );

  const handleClickOpen = () => {
    setOpen(true);
  };

  const updateData = () => {
    incrementCounter();
  };

  const handleClose = () => {
    setSelectedItem(undefined);
    setOpen(false);
  };

  const styles = (theme: Theme) =>
    createStyles({
      root: {
        margin: 0,
        padding: theme.spacing(2),
      },
      closeButton: {
        position: "absolute",
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
      },
    });

  const [counter, updateCounter] = React.useState(0);

  useEffect(() => {
    getSystemTypes().then((req: SystemType[]) => {
      const requestsResponse = (req || []).map((r: SystemType, index) => {
        return {
          cells: [
            {
              data: r.name,
              color: "blue",
              cursor: "pointer",
              onClick: () => {
                setSelectedItem(r);
                setOpen(true);
              },
            },
            { data: formatBool(r.isActive) },
          ],
          data: r,
        };
      });
      console.log(requestsResponse);
      setEnvironment(requestsResponse);
      setEnvironmentMain(requestsResponse);
      setIsloading(false);
    });
  }, [counter]);

  useEffect(() => {
    if (isHideInactiveRecords) {
      const environmentListFiltered = environmentListMain.filter(
        (environment: any) =>
          environment.data.isActive === isHideInactiveRecords
      );
      setEnvironment(environmentListFiltered);
    } else {
      setEnvironment(environmentListMain);
    }
  }, [isHideInactiveRecords, environmentListMain]);

  const incrementCounter = () => {
    updateCounter(counter + 1);
  };

  let editModal = null;
  if (!!selectedItem) {
    editModal = (
      <SystemTypeDetails
        id={0}
        data={selectedItem}
        isOpen={open}
        onClickAdd={updateData}
        onClickClose={handleClose}
      />
    );
  }

  function handleExport() {
    const isActive = isHideInactiveRecords ? 1 : 0;
    exportBusinessUnitsToExcel(isActive);
  }

  function onChange(): void {
    setIsHideInactiveRecords((prev) => !prev);
  }

  const pageName = "Business Units";
  return (
    <Box mt={2}>
      {editModal}
      <MaintenanceBreadcrumbs title={pageName} />
      <Box style={{ float: "right" }}>
        <Form.Checkbox
          label="Hide Inactive Records"
          name="isHideInactiveRecords"
          onChange={onChange}
          size={12}
          value={isHideInactiveRecords}
        />
        <Button onClick={handleExport}>EXPORT TO EXCEL</Button>
      </Box>

      <Table
        data={environmentList}
        tableName={pageName}
        searchPlaceholder="Search by Name"
        searchColumns={[M_TABLE_HEADERS_SYSTEMTYPE.NAME]}
        headers={headers}
        filters={[FilterType.SORT, FilterType.SEARCH, FilterType.PAGINATOR]}
        toolbar="M_SYSTEMTYPE_TOOLBAR"
        onClickAdd={updateData}
        loading={isLoading}
      />
    </Box>
  );
};
